import { requestApi } from './Api';

export const getTags = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/tags/read',
    params
  });

export const createTag = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/tags/create',
    params
  });

export const deleteTag = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/tags/delete',
    params
  });

export const getAllTags = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/tags/get_all',
    params
  });

export const updateTag = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/tags/update',
    params
  });

export const updateTagLink = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/tags/update_tag_link',
    params
  });
